import { render, staticRenderFns } from "./VerDocumentos.vue?vue&type=template&id=d1e67dae&"
import script from "./VerDocumentos.vue?vue&type=script&lang=js&"
export * from "./VerDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports